<template>
  <div id="AboutMeVideo1" :class="sectionClass">
    <VideoPlayer
      class="content"
      src="/static/about-me/v1_720p.mp4"
      cover="/static/about-me/p1.webp"
    />
    <StickMe name="1" size="28" left="-9" top="15" uk-parallax="x: -40%" />
    <StickMe name="2" size="30" left="133" top="41" uk-parallax="x: -85%" />
    <StickMe name="3" size="30" left="110" top="61" uk-parallax="x: -20%" />
    <StickMe name="5" size="11" left="74" top="84" uk-parallax="x: -20%" />
    <StickMe name="4" size="31" left="84" top="84" uk-parallax="y: -40%" />
    <StickMe name="5" size="15" left="100" top="92" uk-parallax="x: -10%" />
    <StickMe
      style="z-index: 0;"
      name="6"
      size="20"
      left="62"
      top="82"
      uk-parallax="x: -90%"
    />
    <StickMe name="5" size="12" left="-6" top="66" uk-parallax="x: -20%" />
    <StickMe name="7" size="22" left="-4" top="36" uk-parallax="y: 150%" />
    <StickMe
      name="8"
      size="49"
      left="-40"
      top="40"
      uk-parallax="target: #AboutMeVideo1; x: 900%; y: -700%"
    />
  </div>
</template>

<script>
import { isMobile } from '@/helpers'
import VideoPlayer from '../VideoPlayer.vue'
import StickMe from './StickMe.vue'

export default {
  components: { VideoPlayer, StickMe },
  computed: {
    sectionClass() {
      return {
        section: !this.isMobile(),
        sectionMobile: this.isMobile(),
      }
    },
  },
  methods: {
    isMobile,
  },
}
</script>

<style lang="scss" scoped>
.section {
  width: 60%;
  scale: 0.85;
}

.sectionMobile {
  width: 90%;
  scale: 0.85;
}
</style>



// WEBPACK FOOTER //
// src/components/about-me/AboutMeVideo1.vue